import type { FC } from "react";

import { Dropdown } from "@alpacahq/ui";
import { classNames } from "@alpacahq/ui/old";

import type { ProfileTabSlug } from "../profileTabs";

interface SettingsTab {
  name: string;
  slug: ProfileTabSlug;
}

interface SettingsNavigationProps {
  tabs: SettingsTab[];
  activeTabSlug: ProfileTabSlug | "";
  onTabChange: (slug: ProfileTabSlug) => void;
}

const SettingsNavigation: FC<SettingsNavigationProps> = ({
  tabs,
  activeTabSlug,
  onTabChange,
}) => {
  return (
    <>
      {/* Mobile tab selector */}
      <div className="min-[990px]:hidden">
        <Dropdown
          fullWidth
          value={activeTabSlug || undefined}
          options={tabs.map((tab) => ({ value: tab.slug, label: tab.name }))}
          onChange={(value) => onTabChange(value as ProfileTabSlug)}
        />
      </div>

      {/* Desktop navigation menu */}
      <aside className="hidden w-full shrink-0 overflow-y-auto border-gray-200 min-[990px]:block min-[990px]:w-56 min-[990px]:pr-8">
        <nav className="flex flex-col gap-2">
          {tabs.map((tab) => (
            <button
              type="button"
              key={tab.slug}
              className={classNames(
                "rounded-md px-3 py-2 text-left font-medium text-sm transition-colors",
                activeTabSlug === tab.slug
                  ? "bg-gray-100 text-black"
                  : "text-gray-600 hover:bg-gray-50",
              )}
              onClick={() => onTabChange(tab.slug)}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default SettingsNavigation;
